import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../models/api-resource.interface';
import { PropositionType } from './proposition-type.interface';

export class PropositionTypeService {
   async getPropositionTypes(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<PropositionType>>>(`/proposition-types`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
